import React, { useState } from 'react';
import './AEquationSolver.css';

const AEquationSolver = () => {
  const [a, setA] = useState('');
  const [b, setB] = useState('');
  const [c, setC] = useState('');
  const [d, setD] = useState('');
  const [expression, setExpression] = useState('ax+b=cx+d');
  const [result, setResult] = useState('');

  const solveEquation = () => {
    const numA = parseFloat(a);
    const numB = parseFloat(b);
    const numC = parseFloat(c);
    const numD = parseFloat(d);

    if (isNaN(numA) || isNaN(numB) || isNaN(numC) || isNaN(numD)) {
      setResult('Please enter valid numbers.');
      return;
    }

    let x;
    switch (expression) {
      case 'ax+b=cx+d':
        x = (numD - numB) / (numA - numC);
        break;
      case 'a+bx=c+dx':
        x = (numC - numA) / (numB - numD);
        break;
      case 'ax-b=cx-d':
        x = (numD + numB) / (numA - numC);
        break;
      case 'a-bx=c-dx':
        x = (numA - numC) / (numD - numB);
        break;
      case 'ax+b=cx-d':
        x = (numD + numB) / (numA - numC);
        break;
      case 'ax-b=cx+d':
        x = (numD - numB) / (numA - numC);
        break;
      case 'a+bx=c-dx':
        x = (numA - numC) / (numB + numD);
        break;
      default:
        setResult('Unknown expression format.');
        return;
    }

    setResult(`x = ${x}`);
  };

  const clearInputs = () => {
    setA('');
    setB('');
    setC('');
    setD('');
    setResult('');
  };

  return (
    <div className="solver-container">
      <h2>Solve the Equation</h2>
      <div className="expression-select">
        <label>
          Select Expression:
          <select value={expression} onChange={(e) => setExpression(e.target.value)}>
            <option value="ax+b=cx+d">ax + b = cx + d</option>
            <option value="a+bx=c+dx">a + bx = c + dx</option>
            <option value="ax-b=cx-d">ax - b = cx - d</option>
            <option value="a-bx=c-dx">a - bx = c - dx</option>
            <option value="ax+b=cx-d">ax + b = cx - d</option>
            <option value="ax-b=cx+d">ax - b = cx + d</option>
            <option value="a+bx=c-dx">a + bx = c - dx</option>
          </select>
        </label>
      </div>
      <div className="input-group">
        <label>
          a:
          <input type="number" value={a} onChange={(e) => setA(e.target.value)} />
        </label>
        <label>
          b:
          <input type="number" value={b} onChange={(e) => setB(e.target.value)} />
        </label>
        <label>
          c:
          <input type="number" value={c} onChange={(e) => setC(e.target.value)} />
        </label>
        <label>
          d:
          <input type="number" value={d} onChange={(e) => setD(e.target.value)} />
        </label>
      </div>
      <button onClick={solveEquation}>Solve</button>
      <button onClick={clearInputs}>Clear</button>
      <div className="result">{result}</div>
    </div>
  );
};

export default AEquationSolver;
